import { NgModule } from '@angular/core'
import { checkTime, SafeHtmlPipe  ,timeFormat,LinkPipe} from './shortname.pipe'
import { SecondToTime} from './minuits.pipe'

@NgModule({
  declarations: [SafeHtmlPipe,SecondToTime,timeFormat ,checkTime,LinkPipe],
  exports: [SafeHtmlPipe,SecondToTime,timeFormat ,checkTime,LinkPipe],
})
export class PipeModule {}
